import React from "react";
import { View } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../utility/AppColors";
import { AppScreens } from "../../screens/Utility/AppScreens";
import LoginWebScreen from "../../screens/Auth/WebScreens/LoginWebScreen";
import TicketDetailWebScreen from "../../screens/Auth/WebScreens/TicketDetailWebScreen";
import SettingWebScreen from "../../screens/Auth/WebScreens/SettingWebScreen";
import StreamSetup from "../../screens/Auth/WebScreens/StreamSetup";
import Notifications from "../../screens/Auth/WebScreens/Notifications/Notifications";
import PaymentDone from "../../screens/Auth/WebScreens/PaymentDone";
import RefundRequestScreen from "../../screens/Auth/WebScreens/RefundRequestScreen";
import DisputeCenter from "../../screens/Auth/WebScreens/DisputeCenter";
import GameShowScreen from "../../screens/Auth/WebScreens/GameShowScreen";
import MyProfileWebScreen from "../../screens/Auth/WebScreens/MyProfileWebScreen";
import ChangeAvatar from "../../screens/Auth/WebScreens/ChangeAvatar";
import CustomDrawerContent from "./CustomDrawerContent";
import {
  HomeTabStack,
  MyEventsTabStack,
  HelpChatTabStack,
  ProfileTabStack,
  PurchaseTabStack,
  HelpTabStack,
  DisputeTabStack,
  NotificationTabStack,
  SettingTabStack,
  ChatTabStack,
} from "./StackNavigators";

const Drawer = createDrawerNavigator();

export default function DesktopNavigation({ dimensions, isAdmin }) {
  return (
    <View style={{ flex: 1 }}>
      <LinearGradient
        colors={[
          AppColors.black,
          AppColors.sidebarBackground_111827,
        ]}
        start={[0, 0]}
        end={[1, 1]}
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        }}
      />
      <Drawer.Navigator
      drawerContent={(props) => <CustomDrawerContent {...props} />}
      screenOptions={{
        swipeEdgeWidth: 0,
        headerShown: false,
        drawerType: dimensions.width >= 768 ? "permanent" : "front",
        drawerStyle: {
          backgroundColor: "transparent",
          width: 200,
        },
      }}
    >
      <Drawer.Screen name="HomeTabStack" component={HomeTabStack} />
      <Drawer.Screen name={"MyEventsTabStack"} component={MyEventsTabStack} />
      <Drawer.Screen name="HelpChatTabStack">
        {() => <HelpChatTabStack isAdmin={isAdmin} />}
      </Drawer.Screen>
      <Drawer.Screen
        name={AppScreens.ProfileMain}
        component={ProfileTabStack}
      />
      <Drawer.Screen
        name={AppScreens.PurchaseTabStack}
        component={PurchaseTabStack}
      />
      <Drawer.Screen name={AppScreens.HelpTabStack} component={HelpTabStack} />
      <Drawer.Screen name="DisputeTabStack" component={DisputeTabStack} />
      <Drawer.Screen
        name={AppScreens.TicketDetailWebScreen}
        component={TicketDetailWebScreen}
      />
      <Drawer.Screen
        name={AppScreens.LoginWebScreen}
        component={LoginWebScreen}
      />
      <Drawer.Screen
        name={AppScreens.SettingWebScreen}
        component={SettingWebScreen}
      />
      <Drawer.Screen name={AppScreens.StreamSetup} component={StreamSetup} />
      <Drawer.Screen
        name={AppScreens.NotificationMain}
        component={NotificationTabStack}
      />
      <Drawer.Screen
        name={AppScreens.SettingMain}
        component={SettingTabStack}
      />
      <Drawer.Screen
        name={AppScreens.NotificationScreen}
        component={Notifications}
      />
      <Drawer.Screen name={AppScreens.PaymentDone} component={PaymentDone} />
      <Drawer.Screen
        name={AppScreens.RefundRequestScreen}
        component={RefundRequestScreen}
      />
      <Drawer.Screen
        name={AppScreens.DisputeCenter}
        component={DisputeCenter}
      />
      <Drawer.Screen
        name={AppScreens.GameShowScreen}
        component={GameShowScreen}
      />
      <Drawer.Screen name={"ChatTabStack"} component={ChatTabStack} />
      <Drawer.Screen
        name={AppScreens.MyProfileWebScreen}
        component={MyProfileWebScreen}
      />
      <Drawer.Screen name={AppScreens.ChangeAvatar} component={ChangeAvatar} />
    </Drawer.Navigator>
    </View>
  );
}